export const mapIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19"><path fill="none" stroke="currentColor" stroke-width="1.2" d="M1 1.5h11.034v5.25H1zm4.966 10.667H17V17.5H5.966zm.551-5.417v1.815l3.863.827 1.102 2.774"/></svg>`,
    name: 'map' as const
};